import React from 'react';

import Image from '@atlaskit/image';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

import { getIllustration, illustrationMap } from './main';
import { type IllustrationComponentProps, type IllustrationProps } from './types';

const rootStyles = xcss({
	display: 'block',
	maxWidth: '100%',
	height: 'auto',
	objectFit: 'contain',
	objectPosition: 'center',
});

const fillStyles = xcss({
	position: 'absolute',
	inset: 'space.0',
	width: '100%',
	height: '100%',
});

const autoDarkStyles = xcss({
	filter: 'invert(1) hue-rotate(180deg)',
});

export const AsImg: React.FC<IllustrationProps> = ({
	srcLight,
	srcDark = srcLight,
	autoDark = true,
	alt,
	fill = false,
	testId,
	...imgProps
}) => {
	const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark';

	return (
		<Box
			xcss={[
				rootStyles,
				...(fill ? [fillStyles] : []),
				...(isDarkMode && srcDark === srcLight && autoDark ? [autoDarkStyles] : []),
			]}
		>
			<Image
				src={isDarkMode && srcDark ? srcDark : srcLight}
				srcDark={srcDark}
				alt={alt}
				testId={testId}
				{...imgProps}
			/>
		</Box>
	);
};

export function Illustration<Props extends IllustrationProps = IllustrationProps>({
	...props
}: Props): React.JSX.Element {
	return <AsImg {...props} />;
}

export const IllustrationComponent = ({
	illustrationKey,
	...props
}: IllustrationComponentProps): React.JSX.Element => {
	const illustration = getIllustration(illustrationKey);
	return (
		<Illustration
			illustrationKey={illustrationKey}
			srcLight={illustration.light}
			srcDark={illustration.dark}
			{...props}
		/>
	);
};

export const illustrationKeys = Object.keys(illustrationMap) as (keyof typeof illustrationMap)[];
